import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/usermgmt.services";
import Breadcrums from "../../common/breadcrumbs";

const UsersView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Center Management"),
      url: "/admin/center-management/center/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];


  useEffect(() => {
    Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {/* <div>
                <h6 className="main-content-label mb-3">{t("View Center")}</h6>
              </div> */}
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>{t("admin.cafes.label_logo")}</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.center_logo
                                ? showdefault.center_logo
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                      {showdefault?.center_banner && 
                      <tr>
                        <th>{t("Center Banner")}</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.center_banner
                                ? showdefault.center_banner
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>}
                      <tr>
                        <th>{t("Center Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.center_name
                            ? showdefault.center_name
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Center ID")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.center_register_id ? showdefault.center_register_id : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("admin.cafes.label_email")}</th>
                        <td>
                          {showdefault && showdefault.email
                            ? showdefault.email
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Location")}</th>
                        <td>
                          {showdefault && showdefault.address
                            ? capitalizeFirstLetter(showdefault.address)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Charge Per Patient")}</th>
                        <td>
                          {showdefault && showdefault.charge_per_patient
                            ? (showdefault.charge_per_patient)
                            : "N/A"}
                        </td>
                      </tr>
                      {/* <tr>
                        <th>{t("Address 1")}</th>
                        <td>
                          {showdefault && showdefault.address1
                            ? capitalizeFirstLetter(showdefault.address1)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Address 2")}</th>
                        <td>
                          {showdefault && showdefault.address2
                            ? capitalizeFirstLetter(showdefault.address2)
                            : "N/A"}
                        </td>
                      </tr> */}
                      <tr>
                        <th>{t("City")}</th>
                        <td>
                          {showdefault && showdefault.city
                            ? capitalizeFirstLetter(showdefault.city)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("PIN Code")}</th>
                        <td>
                          {showdefault && showdefault.pin_code
                            ? capitalizeFirstLetter(showdefault.pin_code)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.cafes.label_phone_number")}</th>
                        <td>
                          {showdefault && showdefault?.phone_number
                            ? showdefault.phone_number
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Phone Number Work")}</th>
                        <td>
                          {showdefault && showdefault?.phone_number_work
                            ? showdefault.phone_number_work
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.list_heading.list_heading_created_date")}</th>
                        <td>
                          {showdefault && showdefault.createdAt
                            ? formateDate(showdefault.createdAt)
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersView;
